import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import TicketGroupCell from './TicketGroupCell'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'
import Router from 'next/router'
import EventAPI from '../api/EventAPI'
import MonetizationAPI from '../api/MonetizationAPI'
import CheckoutForm from './CheckoutForm'
import {Elements, StripeProvider} from 'react-stripe-elements';
import NoSSR from 'react-no-ssr'
import Alert from 'react-bootstrap/Alert'
import Spinner from 'react-bootstrap/Spinner'
import moment from 'moment-timezone'
import ReactGA from 'react-ga'
import InputGroup from 'react-bootstrap/InputGroup'
import FormControl from 'react-bootstrap/FormControl'
import { print } from '../managers/Logger'
import Container from 'react-bootstrap/Container'
import MonetizationManager from '../managers/MonetizationManager'
import v4 from 'uuid/v4'
import ErrorManager from '../managers/ErrorManager'
import UtilsManager from '../managers/UtilsManager'
import { FaCheckCircle } from 'react-icons/fa'
import { connect } from 'react-redux' 
import { consoleLog } from '../managers/Logger'
import { getIdMatch } from '../managers/Utils'
import DownloadPlug from './DownloadPlug'

const startState = { 
			stripe: null,
			stripe_token: null,
			stage: 0, 
			selectedTicketsMap: new Map(),
			email: '', 
			firstName: '', 
			lastName: '', 
			eventApi: new EventAPI(),
			hasError: false,
			errorMessage: '',
			loading: false,
			subscribed: true, 
			code: '', 
			hidden: [],
			visible: [],
			enteredCode: '',
			survey: null,
			surveyCompletionSent: false, 
			sessionId: null, 
			finishedBooking: false,
			result: null,
			frameLoading: true
}

const defaultEventZoneConfig = {
	"pricing": {
        "base": 200,
        "percent": 0.029
    }
}

class BookingModal extends React.Component { 

	constructor(props) { 
		super(props)
		this.state = startState
		this.stripeRef = React.createRef()
		this.monetizationAPI = new MonetizationAPI()
		this.monetizationManager = new MonetizationManager(this.props.event.monetizations)
		this.errorManager = new ErrorManager()
		this.utilsManager = new UtilsManager()
	}

	getTitle() { 
		if (this.state.stage == 0) { 
			return "Choose your Ticket"
		}

		if (this.state.stage == 1) { 
			return "Your information"
		}

		// Assuming there are only two steps aka no payment
		if (this.state.stage == 2) { 
			return null
		}
	}


	getPayment() { 
		const totalDue = this.calculateTotal()
		if (totalDue > 0) { 
			return (
				  <Form.Group>
					  <Form.Label>Payment</Form.Label>
					  	<Elements>
				    		<CheckoutForm
				    			ref={this.stripeRef} />
				        </Elements>
					  </Form.Group>
				)
		} else { 
			return null
		}
	}

	handleSelect(item, index, data) {
		const entry = {
			group_id : item.id, 
			title: item.title,
			cost: item.display_cost,
			count: parseInt(data, 10)
		}
		print(entry)

		var newMap 
		if (entry.count === 0) { 
			const current = this.state.selectedTicketsMap
			current.delete(item.id)
			newMap = current
		} else { 
			newMap = this.state.selectedTicketsMap.set(item.id, entry)
		}
		this.setState({selectedTicketsMap: newMap})
	}

	componentDidMount() { 
		var stripeApiKey = process.env.stripeApiKey;
		if (this.props.appDomain !== "witheta") { 
			stripeApiKey = process.env.spacesStripeApiKey;
		}
		this.setState({stripe: window.Stripe(stripeApiKey)});
		const secretTickets = this.props.event.ticket_groups.filter(other => 
			other.secret_code !== undefined && other.secret_code !== null && other.secret_code !== '')
		const visibleTickets = this.props.event.ticket_groups.filter( group => 
			group.secret_code === undefined || group.secret_code === null || group.secret_code === '')
		this.setState({hidden: secretTickets, visible: visibleTickets})
		const survey = this.monetizationManager.getRequiredSurvey()
		if (survey !== null) { 
			this.setState({survey: survey})
		}

		var redirectUrl = process.env.domain
		print("redirect url is..")
		print(redirectUrl)
	}

	calculateSubTotal() { 
		var sum = 0
		for (var entry of this.state.selectedTicketsMap.values()) { 
			sum += entry.cost * entry.count
		}
		return sum.toFixed(2)
	}

	calculateTotal() {
		const total = parseFloat(this.calculateSubTotal()) + parseFloat(this.calculateServiceFee())
		if (total > 0) { 
			return total.toFixed(2)
		}
		return total
	}

	calculateServiceFee() { 
		var fees = 0
		const eventZoneConfig = this.props.event.zone ? this.props.event.zone.config : defaultEventZoneConfig
		var percent = defaultEventZoneConfig["pricing"]["percent"]
		var base = defaultEventZoneConfig["pricing"]["base"]
		try { 
			percent = eventZoneConfig["pricing"]["percent"] 
			base = eventZoneConfig["pricing"]["base"]
		} catch (e) { 
			consoleLog("No eventZoneConfig..falling back to default definitions")
		}
		base = base / 100

		for (var entry of this.state.selectedTicketsMap.values()) { 
			if (entry.cost !== 0) { 
				fees += entry.cost * entry.count * percent
				fees += entry.count * base
			}
		}
		if (fees > 0) { 
			fees = fees.toFixed(2)
		}
		return fees
	}

	unHideTicket() { 
		const found = this.state.hidden.filter(val => val.secret_code == this.state.enteredCode)
		print(found)
		if (found.length == 0) { 
			alert("no tickets for that code found")
		} else { 
			const newArray = this.state.hidden.filter(val => !found.includes(val))
			const newVisible = [...this.state.visible]
			for (var item of found) {
				newVisible.unshift(item) 
			}
			this.setState({hidden: newArray, visible: newVisible})
		}
	}

	getSecretCodeSearch() { 
		if (this.state.hidden.length > 0){
			return <InputGroup className="mb-3">
					    <FormControl
					      placeholder="Discount code"
					      aria-label="Discount code"
					      aria-describedby="basic-addon2"
					      onChange={(e) => this.setState({enteredCode: e.target.value})}
					    />
					    <InputGroup.Append>
					      <Button variant="outline-secondary"
					      onClick={() => this.unHideTicket()}>Enter</Button>
					    </InputGroup.Append>
	  				</InputGroup>
	  	} else { 
	  		return null
	  	}
	}

	handleSubscribeClick() { 
		if (this.state.subscribed) { 
			ReactGA.event({ 
				category: 'User',
				action: 'user_unsubscribe',
			})
		}
		this.setState({subscribed: !this.state.subscribed})
	}

	getEmail() { 
		if (this.props.appDomain === "witheta") { 
			return "witheta.com"
		}
		return "movement.fm"
	}

	getContent() { 
		if (this.isEventbriteEvent()) { 
			const ebid = getIdMatch(this.props.event.external_url)
			consoleLog("EVENTBRITE ID IS" + ebid)
			
			return <div>
				<div style={{marginBottom: 10}}>
					<DownloadPlug simple id="eventbrite_iframe"></DownloadPlug>
				</div>
				{this.state.frameLoading && <div style={{width: '100%', display: 'flex', justifyContent: 'center', marginTop: 20}}><Spinner animation='border'/></div>}
				<iframe  onLoad={() => this.setState({frameLoading: false})}
				frameBorder={0} allowTransparency style={{width: '100%', height: '500px'}} src={`https://www.eventbrite.com/tickets-external?eid=${ebid}&ref=eta&v=2`} >
				</iframe>
				<small><p>You are booking your ticket with <a href={this.props.event.external_url}>Eventbrite</a> not ETA</p></small>
				</div>
		}

		if (this.state.finishedBooking) { 
			return <div>
				<div style={{justifyContent: 'center', height:100, display: 'flex', alignItems: 'center', justifyContent:'center', alignSelf:'center'}}>
			      		<FaCheckCircle style={{fontSize:50, color: 'green'}}/>
			    </div>
				<p style={{textAlign: 'center'}}>Your ticket has succesfully been booked.</p>
				<p style={{textAlign: 'center', color: 'gray'}}><small>Confirmation Id: {this.state.result && this.state.result.id}</small></p>

				<p style={{textAlign: 'center'}}>You will recieve a email with your receipt and ticket link</p>
				<p style={{fontWeight:'bold', marginTop:10, textAlign: 'center'}}>If you don't see it in your inbox please check your spam folder!</p>

				<p style={{textAlign: 'center', color: 'gray'}}><small>{"Still can't find it? Shoot us an email at support@" + this.getEmail()}</small></p>
			</div>
		}
		if (this.state.stage == 0) { 
			if (this.props.event.ticket_groups == undefined) { 
				return null
			}
			return (
				<div>
					{this.getSecretCodeSearch()}
					{this.state.visible.map((item, index) => {
						return (<TicketGroupCell
								key={index}
								ticketGroup={item}
								onChange={(data) => this.handleSelect(item, index, data)}/>)
						})
					}
				</div>
				)
		}

		if (this.state.stage == 1) { 
			const selectedTickets = Array.from(this.state.selectedTicketsMap.values())
			return (
				<div>
				<Row>
				<Col>
					<Form>
					  <Form.Row>
					    <Form.Group as={Col} controlId="formFirstName">
					      <Form.Label>First Name</Form.Label>
					      <Form.Control value={this.state.firstName}
					      onChange={(e) => this.setState({firstName: e.target.value})}/>
					    </Form.Group>

					    <Form.Group as={Col} controlId="formLastName">
					      <Form.Label>Last Name</Form.Label>
					      <Form.Control value={this.state.lastName}
					      onChange={(e)=> this.setState({lastName: e.target.value})}/>
					    </Form.Group>
	  				  </Form.Row>

					  <Form.Group controlId="formBasicEmail" required="true">
					    <Form.Label>Email address</Form.Label>
					    <Form.Control type="email" placeholder="Enter email"
					    value={this.state.email}
					    onChange={(e)=> this.setState({email:e.target.value})} />
					  </Form.Group>

					  <p> By purchasing a ticket you are agreeing to our <a href="/terms">Terms of Service</a> </p>

					  {this.props.isForTheCulture && <p><strong>ETA is the event platform for the culture.</strong></p>}
					  {this.props.isForTheCulture && <Form.Group>
					  <Form.Check type="checkbox" defaultChecked={this.state.subscribed} 
					  label="Let me know about more dope moves that come up."
					  onChange={(e) => this.handleSubscribeClick()}/>
					  </Form.Group>}

					  {this.getPayment()}
					</Form>
				</Col>
				<Col lg>
				<Card>
				  <Card.Body>
				    <Card.Title>{this.props.event.title}</Card.Title>
				   
				    { selectedTickets.map((item, index) => 

				    	(<div>
				    		<Card.Text>
				      			{item.title} x {item.count} 
				    		</Card.Text>
				    		</div>)
				    	)}

				    <Card.Text style={{marginBottom: 0}}>
				    	Sub total: ${this.calculateSubTotal()}
				    </Card.Text>
				    <Card.Text style={{marginBottom: 0}}>
				    	Service fee: ${this.calculateServiceFee()}
				    </Card.Text>
				    <Card.Text>
				      Total: ${this.calculateTotal()}
				    </Card.Text>
				  </Card.Body>
				</Card>
				</Col>
				</Row>
				</div>
				)
		}

		if (this.state.stage == 2) { 
			return <PollfishSurvey
				survey={this.state.survey}
				surveyCompletionSent = {this.state.surveyCompletionSent}
				onClick={(surveyData) => this.handlePollfishButtonClick(surveyData)}
				onFinish={(completion) => this.handlePollfishSurveyFinish(completion) }
				forceLoading={this.state.loading}
			/>
		}
	}


	async handlePollfishSurveyFinish(completion) {
	
	}

	async finishAndGoToConfirmation() { 
			this.setState({loading: true})
			const info = {
				first_name: this.state.firstName, 
				last_name: this.state.lastName, 
				email : this.state.email, 
				tickets : Array.from(this.state.selectedTicketsMap.values()),
				event_id: this.props.event.id,
				tz: moment.tz.guess(),
				session_id: this.state.sessionId,
				subscribed: this.state.subscribed
			}
			
			if (this.stripeRef.current !== null) { 
				let {token} = await this.stripeRef.current.state.stripe.createToken({name: info.first_name, address_country: 'US'});
				if (token === undefined) { 
					this.setState({hasError: true, errorMessage: 'Please enter valid payment information', loading: false})
					return
				}
				info.token = token
			}
			print(info)
			const result = await this.state.eventApi.bookTickets(info)
			print(result)
			const errorString = this.errorManager.getErrorString(result)
			
			if (errorString !== null) { 
				this.setState({hasError: true, errorMessage: errorString, loading: false})
				return
			}
			this.setState({result: result, hasError: false})

			if (this.props.isForTheCulture) { 
				//TODO: Default homepage on with eta not working..
				// window.location.href = "/confirmation_id=" + result.id;
				this.setState({finishedBooking: true, loading: false});
			} else { 
				this.setState({finishedBooking: true, loading: false})
			}
	}


	async continue() { 
		if (this.state.loading == true) { 
			return; 
		}

		if (this.state.finishedBooking) { 
			this.handleClose();
			return;
		}
		
		ReactGA.event({ 
			category: 'Booking',
			action: 'continue',
			value: this.state.stage
		})
		if (this.state.stage == 0) { 
			if (this.state.selectedTicketsMap.values().length == 0) { 
				this.setState({hasError: true, errorMessage: "Please select a ticket", loading: false})
				return
			}
			this.setState({stage: 1})
		}

		if (this.state.stage == 1) {
			this.setState({sessionId: v4()})
			const totalCost = this.calculateTotal()
			if (this.state.survey !== null && totalCost <= 0 && this.props.pollfish.survey !== null) { 
				this.setState({stage: 2})
			} else { 
				console.log("No required survey found")
				this.finishAndGoToConfirmation()
			}			
		}
	}

	getButtonStatus() {
		if (this.state.loading) { 
			return <Spinner
			      as="span"
			      animation="border"
			      size="sm"
			      role="status"
			      aria-hidden="true"
    			/>
		}

		return "Continue"
	}

	handlePollfishButtonClick(surveyData) { 
		if (this.state.stage == 2 && surveyData !== null) { 
			return window.Pollfish.showFullSurvey()
		} 

		if (this.state.stage == 2 && surveyData === null) { 
			return this.finishAndGoToConfirmation()
		}
	}

	getButton() { 
		if (this.state.stage === 2) { 
			return null
		}

		if (this.isEventbriteEvent()) { 
			return null
		}

		return <Button variant="dark" className="continue_btn" onClick={()=>this.continue()} block
		         disabled={this.getDisabled()}>
		          	{this.getButtonStatus()}
		   </Button>
	
	}

	getDisabled() {
		if (this.state.loading) { 
			return true
		}

		if (this.state.finishedBooking) { 
			return false;
		}
		
		console.log("re-calculaing disabled")
		if (this.state.stage == 0) { 
			var totalCount = 0
			const selectedTickets = Array.from(this.state.selectedTicketsMap.values())
			selectedTickets.map((item, index) => 
			 	totalCount += item.count
			 )
			if (totalCount == 0) { 
				return true
			}
		}
	}

	isEventbriteEvent() { 
		return this.props.event.external_url.includes("eventbrite.com")
	}

	handleClose() { 
		this.setState({stage : 0, finishedBooking: false});
		this.props.handleClose()
	}

	getModal() { 
		if (this.props.noModal) { 
			return <Container>
				<Modal.Title style={{marginBottom: 20, marginTop: 20}}>{this.getTitle()}</Modal.Title>
				<div>
				{this.getContent()}
				</div>
				<Button variant="primary" onClick={()=>this.continue()} block
		         disabled={this.getDisabled()}>
		          	{this.getButtonStatus()}
		        </Button>
			</Container>
		} else { 
		return <Modal
			size="lg" 
			show={this.props.show} onHide={()=>this.handleClose()}>
		    <Modal.Header closeButton>
		      <Modal.Title>{this.getTitle()}</Modal.Title>
		      </Modal.Header>
			<Alert variant='danger' show={this.state.hasError}>
			{this.state.errorMessage}
 			</Alert>
		       <Modal.Body>
		       {this.getContent()}
		       </Modal.Body>

		       <Modal.Footer>
		         {this.getButton()}
		       </Modal.Footer>
       	 </Modal>
		}
	}

	render() { 
		return (
		<StripeProvider stripe={this.state.stripe}>
			{this.getModal()}
       	       </StripeProvider>
			)
	}
}

export default connect(state => state)(BookingModal)